import { type ReactNode } from "react";

import clsx from "clsx";
import { motion } from "framer-motion";

interface Props {
  label: string;
  index: number;
  icon: ReactNode;
  active: boolean;
  complete: boolean;
  disabled?: boolean;
  onClick: () => void;
}

export const StepButton = ({
  label,
  index,
  icon,
  active,
  disabled,
  complete,
  onClick,
}: Props) => {
  return (
    <motion.button
      disabled={active || disabled}
      whileHover={
        active
          ? { color: "#021330", backgroundColor: "#f2f3f5" }
          : {
              color: "#ff0066",
              backgroundColor: "rgba(209, 212, 219, 0.1)",
              transition: { duration: 0.1, ease: "easeIn" },
            }
      }
      style={{
        color: "#021330",
        backgroundColor: active ? "#f2f3f5" : "#ffffff00",
      }}
      className={clsx(
        "flex items-center gap-4 text-left rounded-md py-1 px-1.5",
        "border",
        {
          "border-transparent text-v2-primary": !active,
          "bg-v2-action-tertiary border-v2-tertiary font-bold text-v2-primary":
            active,
          "pointer-events-none text-v2-disabled": disabled,
        },
      )}
      onClick={onClick}
    >
      <span
        className={clsx(
          "relative w-9 h-9 bg-v2-primary rounded border border-v2-tertiary",
          "shrink-0 flex items-center justify-center text-base",
          {
            "shadow-[0_0_10px_rgba(0,0,0,0.06)]": active,
            "text-v2-action": active && !disabled,
          },
        )}
      >
        {icon}
        {complete && (
          <span
            className={clsx(
              "w-[18px] h-[18px] rounded-full flex items-center justify-center",
              "absolute right-0 bottom-0 -mr-[8px] -mb-[4px] border border-v2-background",
              { "bg-v2-action-positive": !disabled, "bg-v2-gray/50": disabled },
            )}
          >
            <i className="fa-regular fa-check text-white text-xxs"></i>
          </span>
        )}
      </span>
      <span className="truncate">
        {index + 1}. {label}
      </span>
    </motion.button>
  );
};
